import { useCallback, useContext } from 'react';
import { UploadStateContext } from '../context';
import { useLatest } from 'ahooks';
import { getFileIndex } from '../utils/utils';
export const useOnRemove = () => {
    const { setValue, onChange, onRemove } = useContext(UploadStateContext);
    const onChangeRef = useLatest(onChange);
    const onRemoveRef = useLatest(onRemove);
    return useCallback((_file) => {
        setValue((prev) => {
            const fileIndex = getFileIndex(_file, prev);
            const file = prev[fileIndex];
            const value = prev.filter((_, index) => fileIndex !== index);
            onChangeRef.current?.(value, { ...file, status: 'remove' });
            onRemoveRef?.current?.(file);
            return value;
        });
    }, [setValue, onRemoveRef, onChangeRef]);
};
